import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import api from '@/lib/api';

/**
 * useFetchList
 *
 * Encapsulates the common pattern of GETing a list resource from the backend
 * with loading + error toast handling. Keeps page components shorter and
 * gives React hooks all the deps they need without leaking implementation
 * details into the consumer.
 */
export default function useFetchList(endpoint, { errorLabel = 'data' } = {}) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get(endpoint);
      setData(response.data);
    } catch (error) {
      const detail = error?.response?.data?.detail || `Failed to load ${errorLabel}`;
      toast.error(detail);
    } finally {
      setLoading(false);
    }
  }, [endpoint, errorLabel]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { data, setData, loading, refresh };
}
